import { el } from './dom.js';

export type PasteRejectReason = 'NO_HTML';

export interface PasteBoxOptions {
  /** Panoda HTML varsa çağrılır; e-Devlet sayfasından kopyalanan seçim buradan gelir. */
  onHtml: (html: string) => void;
  /** Panoda HTML yoksa (Not Defteri'nden düz metin, boş pano) çağrılır. */
  onReject: (reason: PasteRejectReason) => void;
  /** Kutunun içindeki metin; cihaza göre değişir — `pastePlaceholderFor`. */
  placeholder?: string;
}

/**
 * Panodaki `text/html` verisini döndürür. Bir web sayfasından kopyalanan seçim panoya
 * hem düz metin hem HTML olarak gider; HTML yoksa içerik bir sayfadan kopyalanmamıştır.
 */
export function pastedHtml(dt: Pick<DataTransfer, 'getData'> | null | undefined): string | null {
  const html = dt?.getData('text/html') ?? '';
  return html.trim().length > 0 ? html : null;
}

/**
 * Yalnızca yapıştırmayı kabul eden kutu. Klavyeden yazma, sürükleyip bırakma ve düzenleme
 * engellenir; yapıştırılan içerik kutuya yazılmaz, doğrudan ayrıştırıcıya verilir.
 * Böylece dosya yolunda olmayan bir "kutuda düzelt" kapısı açılmaz.
 */
export function mountPasteBox(root: HTMLElement, opts: PasteBoxOptions): HTMLTextAreaElement {
  const box = el('textarea', {
    id: 'pasteBox', class: 'paste-box', rows: '3', autocomplete: 'off', spellcheck: 'false',
    placeholder: opts.placeholder ?? 'Buraya yapıştırın (Ctrl+V)',
    'aria-label': 'e-Devlet sayfasından kopyaladığınız içeriği buraya yapıştırın',
  });
  box.addEventListener('paste', (e) => {
    e.preventDefault();
    const html = pastedHtml((e as ClipboardEvent).clipboardData);
    if (html === null) opts.onReject('NO_HTML');
    else opts.onHtml(html);
  });
  box.addEventListener('beforeinput', (e) => e.preventDefault());
  box.addEventListener('drop', (e) => e.preventDefault());
  root.append(box);
  return box;
}
